module.exports = __webpack_public_path__ + "assets/Angle15.a801f0ed0ea506cfd74958926b700df2.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/Angle15.gmt
// module id = 891
// module chunks = 0